var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    [
      _c("template", { slot: "header" }, [
        _c("div", { staticClass: "header-text" }, [
          _vm._v("Criar oferta de limpeza")
        ])
      ]),
      _vm._v(" "),
      _c("template", { slot: "body" }, [
        _c("div", { staticClass: "city" }, [
          _c("div", { staticClass: "name" }, [
            _vm._v(
              _vm._s(_vm._f("cityName")(_vm.address)) +
                " - " +
                _vm._s(_vm._f("stateCode")(_vm.address))
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "district" }, [
            _vm._v("Bairro " + _vm._s(_vm._f("districtName")(_vm.address)))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body-content" }, [
          _c("div", { staticClass: "date" }, [
            _c("img", { attrs: { src: "/static/calendar-outlined.svg" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.day()) + " - " + _vm._s(_vm.time()))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "duration" }, [
            _c("img", { attrs: { src: "/static/clock-outlined.svg" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.hours()))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "location" }, [
            _c("img", { attrs: { src: "/static/pin.svg" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm._f("name")(_vm.address)))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("Tip", [
            _vm._v(
              "\n      Notificaremos todos os profissionais na sua cidade, inclusive aqueles que não possuem horários disponíveis. Os que desmonstrarem interesse serão exibidos e você poderá escolher o que mais lhe agradar.\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn bg-purple",
              on: {
                click: function($event) {
                  _vm.$emit("createOffer")
                }
              }
            },
            [_c("span", [_vm._v("Criar oferta")])]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn bg-outlined",
              on: {
                click: function($event) {
                  _vm.$emit("closeOrderOfferModal")
                }
              }
            },
            [_c("span", [_vm._v("voltar")])]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc0e6622", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc0e6622","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalOfferList/OrderOffer.vue
// module id = null
// module chunks = 